// extracted by mini-css-extract-plugin
export default {"list":"styles_list__yV2m5","item":"styles_item__pIO-d","hoveredIcon":"styles_hoveredIcon__RHWfx","icon":"styles_icon__nu4xG","active":"styles_active__Bbqaz"};